/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { status } from 'constants/general';

const initialState = {
  priceLists: {
    status: status.SHOULD_CALL_API,
    data: [],
    latestDataLength: null,
  },
  submitPriceList: {
    status: status.SHOULD_CALL_API,
  },
  editPriceList: {
    status: status.SHOULD_CALL_API,
  },
  providers: {
    status: status.SHOULD_CALL_API,
    data: [],
    latestDataLength: null,
  },
  doctors: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
  doctorProfile: {
    status: status.SHOULD_CALL_API,
    data: {},
  },
  submitProvidersBulk: {
    status: status.SHOULD_CALL_API,
  },
  editProvider: {
    status: status.SHOULD_CALL_API,
  },
  removeProvider: {
    status: status.SHOULD_CALL_API,
  },
  dropdownsList: {
    status: status.SHOULD_CALL_API,
    areasList: [],
    specialitiesList: [],
  },
  pharmacies: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
  branches: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
  services: {
    status: status.SHOULD_CALL_API,
    data: [],
    latestDataLength: null,
  },
  addService: {
    status: status.SHOULD_CALL_API,
  },
  removeService: {
    status: status.SHOULD_CALL_API,
  },
  medicalServices: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
  selectedPriceListDetails: {
    status: status.SHOULD_CALL_API,
    data: {},
  },
  entities: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
  entityProviders: {
    status: status.SHOULD_CALL_API,
    data: [],
    latestDataLength: null,
  },
  submitEntityProvider: {
    status: status.SHOULD_CALL_API,
  },
  editEntityProvider: {
    status: status.SHOULD_CALL_API,
  },
  removeEntityProvider: {
    status: status.SHOULD_CALL_API,
  },
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    // Remove Doctor
    editProvider(state) {
      state.editProvider = {
        status: status.SUBMITING,
      };
    },
    editProviderSuccess(state) {
      state.editProvider = {
        status: status.SUCCESS,
      };
    },
    editProviderFail(state) {
      state.editProvider = {
        status: status.FAIL,
      };
    },
    // Remove Doctor
    removeProvider(state) {
      state.removeProvider = {
        status: status.SUBMITING,
      };
    },
    removeProviderSuccess(state) {
      state.removeProvider = {
        status: status.SUCCESS,
      };
    },
    removeProviderFail(state) {
      state.removeProvider = {
        status: status.FAIL,
      };
    },
    // Submit Doctors List
    submitProvidersBulk(state) {
      state.submitProvidersBulk = {
        status: status.SUBMITING,
      };
    },
    submitProvidersBulkSuccess(state) {
      state.submitProvidersBulk = {
        status: status.SUCCESS,
      };
    },
    submitProvidersBulkFail(state) {
      state.submitProvidersBulk = {
        status: status.FAIL,
      };
    },
    // Search Doctors
    fetchDoctorProfile(state) {
      state.submitProvidersBulk = {
        status: status.FETCHING,
        data: {},
      };
    },
    fetchDoctorProfileSuccess(state, action) {
      state.doctorProfile = {
        status: status.SUCCESS,
        data: action.payload || {},
      };
    },
    fetchDoctorProfileFail(state) {
      state.doctorProfile = {
        status: status.FAIL,
      };
    },
    // Search Doctors
    fetchDoctorsList(state, action) {
      const { page } = action.payload;
      state.doctors = {
        status: status.FETCHING,
        data: page === 1 ? [] : state.doctors.data,
      };
    },
    fetchDoctorsListSuccess(state, action) {
      let list = [];
      if (state.doctors.data.length) {
        list = [...state.doctors.data, ...action.payload];
      } else {
        list = [...action.payload];
      }

      state.doctors = {
        status: status.SUCCESS,
        data: list,
      };
    },
    fetchDoctorsListFail(state) {
      state.doctors = {
        status: status.FAIL,
      };
    },
    // Fetch Price Lists
    fetchPriceLists(state, action) {
      const { isShowMore } = action.payload;
      state.priceLists = {
        status: status.FETCHING,
        data: isShowMore ? state.priceLists.data : [],
        latestDataLength: state.providers.data?.length,
      };
    },
    fetchPriceListsSuccess(state, action) {
      state.priceLists = {
        status: status.SUCCESS,
        data: [...state.priceLists.data, ...action.payload],
        latestDataLength: action.payload.length,
      };
    },
    fetchPriceListsFail(state) {
      state.priceLists = {
        status: status.FAIL,
      };
    },
    // Create Price List
    submitPriceList(state) {
      state.submitPriceList = {
        status: status.SUBMITING,
      };
    },
    submitPriceListSuccess(state) {
      state.submitPriceList = {
        status: status.SUCCESS,
      };
    },
    submitPriceListFail(state) {
      state.submitPriceList = {
        status: status.FAIL,
      };
    },
    // Edit Price List
    editPriceList(state) {
      state.editPriceList = {
        status: status.SUBMITING,
      };
    },
    editPriceListSuccess(state) {
      state.editPriceList = {
        status: status.SUCCESS,
      };
    },
    editPriceListFail(state) {
      state.editPriceList = {
        status: status.FAIL,
      };
    },
    fetchProviders(state, action) {
      const { isShowMore } = action.payload;
      state.providers = {
        status: status.FETCHING,
        data: isShowMore ? state.providers.data : [],
        latestDataLength: state.providers.data?.length,
      };
    },
    fetchProvidersSuccess(state, action) {
      state.providers = {
        status: status.SUCCESS,
        data: [...state.providers.data, ...action.payload],
        latestDataLength: action.payload.length,
      };
    },
    fetchProvidersFail(state) {
      state.providers = {
        status: status.FAIL,
      };
    },
    clearBranches(state) {
      state.branches = {
        status: status.SHOULD_CALL_API,
        data: [],
      };
    },
    fetchBranches(state) {
      state.branches = {
        status: status.FETCHING,
        data: [],
      };
    },
    fetchBranchesSuccess(state, action) {
      state.branches = {
        status: status.SUCCESS,
        data: action.payload || [],
      };
    },
    fetchBranchesFail(state) {
      state.branches = {
        status: status.FAIL,
      };
    },
    fetchDropdowns(state) {
      state.dropdownsList = {
        status: status.FETCHING,
        areasList: [],
        specialitiesList: [],
      };
    },
    fetchDropdownsSuccess(state, action) {
      state.dropdownsList = {
        status: status.SUCCESS,
        areasList: action.payload.areas,
        specialitiesList: action.payload.specialities,
      };
    },
    fetchDropdownsFail(state) {
      state.dropdownsList = {
        status: status.FAIL,
      };
    },
    // Search Pharmcies
    fetchPharmaciesList(state) {
      state.pharmacies = {
        status: status.FETCHING,
        data: [],
      };
    },
    fetchPharmaciesListSuccess(state, action) {
      state.pharmacies = {
        status: status.SUCCESS,
        data: action.payload || [],
      };
    },
    fetchPharmaciesListFail(state) {
      state.pharmacies = {
        status: status.FAIL,
      };
    },
    // Services
    fetchServicesList(state, action) {
      const { isShowMore } = action.payload;
      state.services = {
        status: status.FETCHING,
        data: isShowMore ? state.services.data : [],
        latestDataLength: state.services.data?.length,
      };
    },
    fetchServicesListSuccess(state, action) {
      state.services = {
        status: status.SUCCESS,
        data: [...state.services.data, ...action.payload],
        latestDataLength: action.payload.length,
      };
    },
    fetchServicesListFail(state) {
      state.services = {
        status: status.FAIL,
      };
    },
    // Add Service
    addService(state) {
      state.addService = {
        status: status.SUBMITING,
      };
    },
    addServiceSuccess(state) {
      state.addService = {
        status: status.SUCCESS,
      };
    },
    addServiceFail(state) {
      state.addService = {
        status: status.FAIL,
      };
    },
    // Remove Service
    removeService(state) {
      state.removeService = {
        status: status.SUBMITING,
      };
    },
    removeServiceSuccess(state) {
      state.removeService = {
        status: status.SUCCESS,
      };
    },
    removeServiceFail(state) {
      state.removeService = {
        status: status.FAIL,
      };
    },
    clearMedicalServices(state) {
      state.medicalServices = {
        status: status.SHOULD_CALL_API,
        data: [],
      };
    },
    fetchMedicalServices(state) {
      state.medicalServices = {
        status: status.FETCHING,
        data: [],
      };
    },
    fetchMedicalServicesSuccess(state, action) {
      state.medicalServices = {
        status: status.SUCCESS,
        data: action.payload || [],
      };
    },
    fetchMedicalServicesFail(state) {
      state.medicalServices = {
        status: status.FAIL,
      };
    },
    fetchSelectedPriceListDetailsSuccess(state, action) {
      state.selectedPriceListDetails = {
        status: status.SUCCESS,
        data: action.payload || {},
      };
    },
    fetchEntities(state, action) {
      const { page } = action.payload;

      state.entities = {
        status: status.FETCHING,
        data: page === 1 ? [] : state.entities.data,
      };
    },
    fetchEntitiesSuccess(state, action) {
      const { payload } = action;
      const { results, override } = payload;

      let list = [];
      if (state.entities.data.length && !override) {
        list = [...state.entities.data, ...results];
      } else {
        list = [...results];
      }

      state.entities = {
        status: status.SUCCESS,
        data: list,
      };
    },
    fetchEntitiesFail(state) {
      state.entities = {
        status: status.FAIL,
      };
    },
    fetchEntityProviders(state, action) {
      const { isShowMore } = action.payload;

      state.entityProviders = {
        status: status.FETCHING,
        data: isShowMore ? state.entityProviders.data : [],
        latestDataLength: state.entityProviders.data?.length,
      };
    },
    fetchEntityProvidersSuccess(state, action) {
      state.entityProviders = {
        status: status.SUCCESS,
        data: [...state.entityProviders.data, ...action.payload],
        latestDataLength: action.payload.length,
      };
    },
    fetchEntityProvidersFail(state) {
      state.entityProviders = {
        status: status.FAIL,
      };
    },
    submitEntityProvider(state) {
      state.submitEntityProvider = {
        status: status.SUBMITING,
      };
    },
    submitEntityProviderSuccess(state) {
      state.submitEntityProvider = {
        status: status.SUCCESS,
      };
    },
    submitEntityProviderFail(state) {
      state.submitEntityProvider = {
        status: status.FAIL,
      };
    },
    editEntityProvider(state) {
      state.editEntityProvider = {
        status: status.SUBMITING,
      };
    },
    editEntityProviderSuccess(state) {
      state.editEntityProvider = {
        status: status.SUCCESS,
      };
    },
    editEntityProviderFail(state) {
      state.editEntityProvider = {
        status: status.FAIL,
      };
    },
    removeEntityProvider(state) {
      state.removeEntityProvider = {
        status: status.SUBMITING,
      };
    },
    removeEntityProviderSuccess(state) {
      state.removeEntityProvider = {
        status: status.SUCCESS,
      };
    },
    removeEntityProviderFail(state) {
      state.removeEntityProvider = {
        status: status.FAIL,
      };
    },
  },
});

export const {
  fetchPriceLists,
  fetchPriceListsSuccess,
  fetchPriceListsFail,
  submitPriceListSuccess,
  editPriceList,
  editPriceListFail,
  editPriceListSuccess,
  submitPriceList,
  submitPriceListFail,
  fetchProviders,
  fetchProvidersSuccess,
  fetchProvidersFail,
  fetchDoctorProfile,
  fetchDoctorProfileFail,
  fetchDoctorProfileSuccess,
  fetchDoctorsList,
  fetchDoctorsListFail,
  fetchDoctorsListSuccess,
  editProvider,
  editProviderSuccess,
  editProviderFail,
  removeProvider,
  removeProviderSuccess,
  removeProviderFail,
  submitProvidersBulk,
  submitProvidersBulkFail,
  submitProvidersBulkSuccess,
  fetchDropdowns,
  fetchDropdownsSuccess,
  fetchDropdownsFail,
  fetchBranches,
  fetchBranchesFail,
  fetchBranchesSuccess,
  fetchPharmaciesList,
  fetchPharmaciesListFail,
  fetchPharmaciesListSuccess,
  fetchServicesList,
  fetchServicesListSuccess,
  fetchServicesListFail,
  addService,
  addServiceSuccess,
  addServiceFail,
  removeService,
  removeServiceSuccess,
  removeServiceFail,
  fetchMedicalServices,
  fetchMedicalServicesSuccess,
  fetchMedicalServicesFail,
  clearBranches,
  clearMedicalServices,
  fetchSelectedPriceListDetailsSuccess,
  fetchEntities,
  fetchEntitiesSuccess,
  fetchEntitiesFail,
  fetchEntityProviders,
  fetchEntityProvidersSuccess,
  fetchEntityProvidersFail,
  submitEntityProvider,
  submitEntityProviderSuccess,
  submitEntityProviderFail,
  editEntityProvider,
  editEntityProviderSuccess,
  editEntityProviderFail,
  removeEntityProvider,
  removeEntityProviderSuccess,
  removeEntityProviderFail,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
